import PropTypes from 'prop-types';
import React from 'react';
import VM from 'scratch-vm';

import UserCenterComponent from '../components/user-center/user-center.jsx';

const UserCenter = props => (
    <UserCenterComponent
        initialTab={props.initialTab}
        vm={props.vm}
        onRequestClose={props.onRequestClose}
    />
);

UserCenter.propTypes = {
    initialTab: PropTypes.string,
    onRequestClose: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default UserCenter;
